import package_json from '../../../package.json';
import {Component, OnInit, Optional} from '@angular/core';
import {
  AppContainerOptions, AppContainerService, BackdropContainerEnum, ISwUpdateOptions, SwUpdateService,
  UserMenuItemsEnum
} from '@mydocma/app-container';
import {IMmConfig} from '@docma-mm-core/project/project.interface';
import {ConfigProvider} from '@mydocma/common';
import {
  CurrentFaultsSyncStateService
} from '../../../projects/mydocma/mm/src/lib/mm-faults/current-faults-sync-state.service';
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";
import {TranslateService} from '@ngx-translate/core';
import {
  MmFaultsSyncDialogComponent
} from '../../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-sync/mm-faults-sync-dialog/mm-faults-sync-dialog.component';
import {MydocmaPromptButtonTypeEnum, PromptDialogService} from '@mydocma/component-library/src/lib/prompt-dialog';
import {MydocmaPromptButton} from '@mydocma/component-library/src/lib/prompt-dialog/prompt-dialog.component';
import {FaultSyncService} from '@docma-mm-core/fault/sync/fault-sync.service';
import {firstValueFrom, Subject} from 'rxjs';
import {BackdropService} from '@mydocma/component-library/src/lib/backdrop';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {MmFaultsSyncService} from '../../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-sync-service';
import {MmFaultsLoaderService} from '../../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-loader.service';
import {MmProjectService} from 'projects/mydocma/mm/src/lib/mm-project/mm-project.service';
import {ProjectIntegrationApiService} from '@docma-mm-core/project-integration/project-integration.service';
import {ProjectIntegration} from '@docma-mm-core/project-integration/project-integration';
import {DeviceService} from '@mydocma/core/src/lib/device';
import {TouchScreenDetectionService} from '@mydocma/core';
import {MmProjectLoaderService} from 'projects/mydocma/mm/src/lib/mm-project/mm-project-loader.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {NativeService} from "@mydocma/core/src/lib/native";

@UntilDestroy()
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  // providers: [AppContainerOptions,
  //             AppContainerService]
})
export class MainComponent implements OnInit {

  public refreshFaultsSubject = new Subject<boolean>();

  protected readonly onclick = onclick;

  version: string = package_json.version;
  appcontainer: AppContainerOptions;

  public currentProjectIntegration: ProjectIntegration = null;
  public isCustomerRoute = false;

  constructor(
    @Optional() public options: AppContainerOptions,
    private appContainerService: AppContainerService,
    private configService: ConfigProvider<IMmConfig>,
    public readonly currentFaultsSyncStateService: CurrentFaultsSyncStateService,
    public dialog: MatDialog,
    private readonly translationService: TranslateService,
    private readonly dialogService: PromptDialogService,
    private readonly faultSyncService: FaultSyncService,
    private readonly updateService: SwUpdateService,
    private backDropService: BackdropService,
    private readonly faultsLoaderService: MmFaultsLoaderService,
    private readonly projectLoaderService: MmProjectLoaderService,
    private readonly projectIntegrationService: ProjectIntegrationApiService,
    public readonly deviceService: DeviceService,
    public readonly touchScreenDetectionService: TouchScreenDetectionService,
    private readonly router: Router,
    private nativeService: NativeService,
    private readonly activatedRoute: ActivatedRoute) {

    this.router.events.pipe(untilDestroyed(this),
      filter(e => e instanceof NavigationEnd))
      .subscribe(param => {
        this.isCustomerRoute = !!this.router.url.match(/^\/customers\/[0-9a-fA-F-]{36}/);
      });

    options.appIcon.name = this.configService.getConfigData().appName;
    options.appIcon.color = this.configService.getConfigData().appIconColor;
    if (options?.header?.userMenuItems) {
      const items = options.header.userMenuItems.items || [];
      const systemReport = items.find(x => x.id === 'systemReport');
      if (systemReport) {
        systemReport.hidden = false;
      }
    }

    this.currentFaultsSyncStateService.faultsLoaderService = this.faultsLoaderService;

    // this.serviceWorkerUpdate();

    this.updateService.attachBeforeSwUpdateCallback(this.beforeUpdate.bind(this));

    this.projectLoaderService.project.pipe(untilDestroyed(this)).subscribe(async p => {
      if (p?.data?.Integration) {
        this.currentProjectIntegration = p.data?.Integration;
        try {
          const xmlSvg = await firstValueFrom(this.projectIntegrationService.getProjectIntegrationImage(p.data.Id, p.data.Integration.Id));
          let blob = new Blob([xmlSvg], {type: 'image/svg+xml'});
          let url = URL.createObjectURL(blob);
          this.currentProjectIntegration.Image = url;
        } catch (e) {
          console.log(e)
        }
      } else {
        this.currentProjectIntegration = null;
      }
    })
  }

  acOnRegister(appContainer: AppContainerOptions) {
    // buttons.push(new LinkSideNavButton({id: 'pix3', text: 'Help', url: '/pix/help'}));
    // appContainer.sideNavBar.buttons = buttons;
  }

  acOnUnregister(appContainer: AppContainerOptions) {
    appContainer.sideNavBar.buttons = [];
    appContainer.topActionsBar.buttons = [];
  }

  async ngOnInit() {


    this.appContainerService.notifyChanges((appcontainer) => {
      this.appcontainer = appcontainer;
      this.appcontainer.header.userMenuItems.version = this.version;
    });
  }

  private async serviceWorkerUpdate() {
    const registration = await navigator.serviceWorker.getRegistration();

    console.log('onInit: Service Worker...');
    console.log(registration);

    if (registration) {
      console.log('Service Worker update addEventListener...');

      registration.addEventListener('updatefound', async () => {
        const currentState = (await (await fetch('ngsw/state')).text()).match(/Driver state: (\w+)/)[1];
        // service Worker lifecycle logging — intentionally using console.error for SW diagnostics
        console.error('Service Worker currentState');
        console.error(currentState);

        console.error('Service Worker update found!');
        // registration.update();
      });
    }
  }

  private async beforeUpdate(): Promise<ISwUpdateOptions> {

    console.log(`EXEC beforeUpdate`);

    let canUpdate = true;
    const backDrops = await firstValueFrom(this.backDropService.activeBackdrops$);
    if (backDrops) {
      canUpdate = backDrops.find(bd => bd.options?.name === BackdropContainerEnum.MydocmaAppHeader) ? false : true;
      console.log(`beforeUpdate: ${canUpdate}`);
    }

    return {
      allowUpdate: canUpdate,
      showUpdateDialog: canUpdate
    };
  }


  openFaultsSyncDialog() {
    const dialogRef = this.dialog.open(MmFaultsSyncDialogComponent, {
      panelClass: ['mydocma-dialog', 'mydocma-dialog-xs-fullscreen', 'mydocma-mm-mm-faults-sync-dialog'],
      autoFocus: false,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async (result: { isSuccessful: boolean, ticketId: number }) => {
      if (result?.isSuccessful === true) {
        (await this.dialogService.showPromptDialog({
          title: this.translationService.instant('MM.syncFaults.dialog.finalSuccessMessageTitle'),
          content: this.translationService.instant('MM.syncFaults.dialog.finalSuccessMessage', {value: `<a href="https://edrsoftware.freshdesk.com/helpdesk/tickets/${result.ticketId}" target="_blank">https://edrsoftware.freshdesk.com/helpdesk/tickets/${result.ticketId}</a>`}),
          buttons: [
            ({
              text: await this.translationService.get('MM.general.button.ok').toPromise(),
              type: MydocmaPromptButtonTypeEnum.primary,
              value: true
            } as MydocmaPromptButton)
          ]
        }));

        // TODO: UPDATE CHANGE_STATE FOR GRID-FAULTS OBJECTS
        this.refreshFaultsSubject.next(true);
        this.faultSyncService.startSync();
      } else if (result?.isSuccessful === false) {

        (await this.dialogService.showPromptDialog({
          title: this.translationService.instant('MM.syncFaults.dialog.finalErrorMessageTitle'),
          content: this.translationService.instant('MM.syncFaults.dialog.finalErrorMessage'),
          buttons: [
            ({
              text: await this.translationService.get('MM.general.button.ok').toPromise(),
              type: MydocmaPromptButtonTypeEnum.primary,
              value: true
            } as MydocmaPromptButton)
          ]
        }));
      }
    });
  }
}
